import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Copy16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.5 1.25C4.80964 1.25 4.25 1.80964 4.25 2.5L4.25 10.5C4.25 11.1904 4.80964 11.75 5.5 11.75H13.5C14.1904 11.75 14.75 11.1904 14.75 10.5V2.5C14.75 1.80964 14.1904 1.25 13.5 1.25H5.5ZM5.75 10.25V2.75L13.25 2.75V10.25H5.75Z'
      fill='currentColor'
    />
    <path
      d='M2.75 4V13.25H12V14.75H2.5C1.80964 14.75 1.25 14.1904 1.25 13.5V4H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Copy16.displayName = 'Copy16';
export default Copy16;
